import {Expose, Type} from "class-transformer";
import PaymentWalletBalance from "@models/operations/components/PaymentWalletBalance";

export default class PaymentWallet {
	@Expose({name: 'balance'})
	@Type(() => PaymentWalletBalance)
	private _balance: PaymentWalletBalance | null = null;

	@Expose({name: 'enabled'})
	private _enabled: boolean = false;

	get balance(): PaymentWalletBalance | null {
		return this._balance;
	}

	get enabled(): boolean {
		return this._enabled;
	}
}
